var map = {
	"./all-black.jpg": "8d82",
	"./diamonds.jpg": "e8d6",
	"./gallan.jpg": "63fa",
	"./jaani.jpg": "de54",
	"./needya.jpg": "b9d3",
	"./only.jpg": "6b99",
	"./rehab.jpg": "04bb",
	"./suicide.jpg": "dedb",
	"./work.jpg": "d062",
	"./you-da-one.jpg": "a39a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bda1";